import { defineAsyncComponent } from 'vue'

export const blocksBlockEditor: Record<string, {}> = {
  paragraph: defineAsyncComponent(() =>
    import('~/components/components/block-editor/Paragraph.vue')
  ),
  nestedlist: defineAsyncComponent(() =>
    import('~/components/components/block-editor/NestedList.vue')
  ),
  header: defineAsyncComponent(() =>
    import('~/components/components/block-editor/Header.vue')
  )
}
